export const dashboard = {
  professor: {
    title: 'Painel do professor',
    description: 'Visão de produção dos seus cursos.',
    selecionarCurso: 'Selecione um curso',
    cursoPlaceholder: 'Escolha um curso para ver as métricas',
    semCursos: 'Você ainda não tem cursos.',
    semSelecao: 'Selecione um curso acima para ver as métricas de consumo.',
    metricas: {
      matriculados: 'Matriculados',
      matriculadosHint: 'Alunos na população do curso.',
      taxaConclusao: 'Taxa de conclusão',
      taxaConclusaoHint: 'Conta quem concluiu (marco histórico), não quem está em 100% agora.',
    },
    quizzes: {
      title: 'Médias por quiz',
      aula: 'Aula-quiz',
      media: 'Média (nota repres.)',
      tentantes: 'Tentaram',
      empty: 'Este curso não tem aulas de quiz.',
    },
  },
  curador: {
    title: 'Painel do curador',
    description: 'Acompanhamento das suas atribuições.',
    abas: { trilha: 'Trilha', curso: 'Curso' },
    selecionarTrilha: 'Selecione uma trilha',
    trilhaPlaceholder: 'Escolha uma trilha',
    selecionarCurso: 'Selecione um curso',
    cursoPlaceholder: 'Escolha um curso',
    semTrilhas: 'Nenhuma trilha disponível.',
    semCursos: 'Nenhum curso disponível.',
    semSelecaoTrilha: 'Selecione uma trilha acima para ver o acompanhamento.',
    semSelecaoCurso: 'Selecione um curso acima para ver o acompanhamento.',
    recorteHint: 'Mostra apenas quem você atribuiu.',
    contadores: {
      matriculados: 'Matriculados',
      concluidos: 'Concluídos',
      atrasados: 'Atrasados',
      emRisco: 'Em risco',
    },
  },
  admin: {
    title: 'Visão global',
    description: 'Totais do sistema inteiro, sem cortes organizacionais.',
    totais: {
      usuariosAtivos: 'Usuários ativos',
      trilhasAtivas: 'Trilhas ativas',
      conclusoes: 'Conclusões',
    },
    busca: {
      title: 'Buscar usuário',
      placeholder: 'Buscar usuário por nome ou e-mail...',
      ocioso: 'Digite um nome ou e-mail para localizar usuários.',
      vazio: 'Nenhum usuário encontrado.',
      colunas: {
        nome: 'Nome',
        email: 'E-mail',
        perfis: 'Perfis',
        status: 'Status',
        acoes: 'Ações',
      },
      abrirGestao: 'Abrir na gestão',
    },
  },
} as const;
